import { render, staticRenderFns } from "./_videoPlay.vue?vue&type=template&id=2179cdda&scoped=true"
import script from "./_videoPlay.vue?vue&type=script&lang=js"
export * from "./_videoPlay.vue?vue&type=script&lang=js"
import style0 from "./_videoPlay.vue?vue&type=style&index=0&id=2179cdda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2179cdda",
  null
  
)

export default component.exports